import {OriginatorRulesState} from "@/store/rules/originator_rules/types";
import {Module} from "vuex";
import {RootState} from "@/store/types";
import {getters} from "@/store/rules/originator_rules/getters";
import {mutations} from "@/store/rules/originator_rules/mutations";
import {actions} from "@/store/rules/originator_rules/actions";

export const state: OriginatorRulesState = {
  originatorRules: []
}

export const originatorRules: Module<OriginatorRulesState, RootState> = {
  state,
  getters,
  mutations,
  actions
}